import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { matchValidator } from "../_directives/passwords-match.validator";
import { RakazPasswordValidator } from "../_directives/rakaz-password.validator";
import { TranslationService } from "../_services/translation.service";
import { ITranslations } from "../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { PasswordResetService } from "../_services/password-reset.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { GenericModalComponent } from "../form/generic-app-modal/generic-modal.component";

const VALIDATE_PASSWORD = true;

@Component({
  moduleId: module.id,
  templateUrl: "rest-user-password.component.html",
  styleUrls: [
    "../forgotpassword/forgotpassword.component.scss",
    "rest-user-password.component.scss",
  ],
})
//  forgot_password?token=cguebo-4e266030763454c214134327&email=chenpeleg@gmail.com
export class RestUserPasswordComponent implements OnInit {
  public isLoading: boolean = false;
  public translations$: Observable<ITranslations>;
  public passwordResetForm = new FormGroup(
    {
      password: new FormControl("", {
        validators: [
          Validators.required,
          VALIDATE_PASSWORD ? new RakazPasswordValidator().validate : null,
        ].filter((v) => v !== null),
      }),
      confirmPassword: new FormControl("", {
        validators: [Validators.required],
      }),
    },
    { validators: matchValidator("password", "confirmPassword") }
  );
  public paramData: any = { token: "", email: "" };
  public isPasswordVisible: boolean = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private sessionManager: SessionManagerService,
    private translationService: TranslationService,
    private restUserPasswordService: PasswordResetService,
    private modalService: NgbModal
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.paramData.token = params["token"];
      this.paramData.email = params["email"];
    });
  }
  public getErrorMessage() {
    if (
      this.passwordResetForm.errors &&
      this.passwordResetForm.errors["confirmedPasswordMatchValidator"]
    ) {
      return this.translationService.currentTranslations.passwords_dont_match;
    }
    const passwordControls = this.passwordResetForm.controls.password;
    const passwordErrors = passwordControls.errors;
    if (
      passwordErrors &&
      passwordErrors["tooWeakPassword"] &&
      passwordControls.dirty &&
      passwordControls.touched
    ) {
      return this.translationService.currentTranslations
        .must_use_a_strong_password;
    }
    return null;
  }

  public async onSubmit() {
    this.isLoading = true;
    const result = await this.restUserPasswordService.resetPassword(
      this.paramData.email,
      this.paramData.token,
      this.passwordResetForm.value.password
    );
    this.isLoading = false;
    if (result.success) {
      this.alertService.success(
        this.translationService.currentTranslations.reset_password
      );
      await this.showErrorMessage("הסיסמה שונתה בהצלחה. נא להתחבר מחדש");
      await this.router.navigate(["/login"]);
    } else if (result.success === false) {
      let message = "אירעה שגיאה באיפוס הסיסמה";

      if (result.error && result.error.statusText) {
        message = result.error.statusText;
      }
      const modalApproval = await this.showErrorMessage(message);
    }
  }

  public toggleVisibility($event: MouseEvent) {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  protected async showErrorMessage(message: string) {
    const modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "איפוס סיסמה",
      modalText,
      onlyApprove: true,
    };
    return modalRef.result;
  }
}



// WEBPACK FOOTER //
// ./src/app/reset-user-password/rest-user-password.component.ts